exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-26ba2b43] .dropdown-menu {\n  margin-left: 0;\n}\n.bibleCloudTranslationSelector-menu[data-v-26ba2b43] {\n  margin-top: 8px;\n}\n.bibleCloudDropdown-section-title[data-v-26ba2b43] {\n  margin: 0 9px;\n}\n.bibleCloudTranslationSelector-link[data-v-26ba2b43] {\n  color: #111;\n  display: block;\n  text-decoration: none;\n  margin: 4px 0;\n  padding: 6px 19px;\n}\n.bibleCloudTranslationSelector-link.bibleCloudTranslationSelector-link-current[data-v-26ba2b43], .bibleCloudTranslationSelector-link[data-v-26ba2b43]:hover {\n  background: #eff1f6;\n}", ""]);

// exports
